import React, { useState } from "react";
import { Button, Input, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";
import DataProvider from "../../apis";

export default function Passwordoptions(props: any) {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { emailPlaceholder, emailDomain, noBack, title, description, onBack } = props;

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setEmail(e.target.value);
  };

  const handleGetCode = async () => {
    const email = (props.email || "").trim().toLowerCase();
    if (!email || email.length < 5) {
      api.warning({
        message: "Invalid Email",
        description: "Enter a valid email address.",
      });
      return;
    }

    setLoading(true);
    try {
      const response: AxiosResponse<{ message: string }> = await DataProvider.forgotpassword({ email });
      setLoading(false);
      if (response.data?.message) {
        api.info({
          message: "Code sent",
          description: response.data.message,
        });
      }
      props.setInnerTab(1);
    } catch (error: unknown) {
      setLoading(false);
      const message =
        error && typeof error === "object" && "response" in error
          ? (error as { response?: { data?: { message?: string } } }).response?.data?.message
          : null;
      api.error({
        message: "Password reset",
        description: message ?? "This email is not registered. Please sign up or try another address.",
      });
    }
  };

  return (
    <div className=" p-4 border border-gray-300 rounded-lg  bg-white max-w-[320px] mx-auto sm:max-w-[384px] md:max-w-[448px] lg:max-w-[512px] xl:max-w-[576px] ">
      <h3 className="text-lg font-semibold mb-2">
        {title || "Get back into your doctor account"}
      </h3>
      <h3 className="text-lg font-semibold mb-4">
        {/* {title || "How would you like to get your security code?"} */}
      </h3>
      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">
          {description ||
            "To reset your password, enter the email address associated with your doctor account. We will send a verification code to your email."}
        </p>
        <Input
          placeholder={emailPlaceholder || "Enter your doctor registered email"}
          value={props.email}
          onChange={handleEmailChange}
          suffix={emailDomain}
          className="mt-2"
        />
      </div>
      <div className="flex justify-between">
        {!noBack && (
          <Button onClick={onBack || (() => navigate(-1))} className="mr-2">
            Cancel
          </Button>
        )}
        <Button
          //   type="primary"
          onClick={handleGetCode}
          loading={loading}
          //   disabled={!verificationMethod || loading}
          className="bg-[#1A94EC] text-white hover:text-[#1A94EC]"
        >
          {loading ? "Checking..." : "Get code"}
        </Button>
      </div>
      {contextHolder}
    </div>
  );
}
